export const VERSION_MANAGEMENT_PATH = "/version-management";
export const NEW_RELEASE_PATH = `${VERSION_MANAGEMENT_PATH}/releases/new`;

export const releasePagePath = (version: string) =>
  `${VERSION_MANAGEMENT_PATH}/releases/${version}`;
